import React, { useRef, useState } from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import Changes from "../../common/Changes";
import SelectionRights from "../../common/SelectionRights";

/**
 * TABLE SYSTEMCOLORS
 */
function AgentRights({ IdAgent }) {
  const agentRightsRef = useRef(null);
  const agentReportRef = useRef(null);


  const handleSaveFromParent = () => {
    [agentRightsRef, agentReportRef].forEach(ref => {
      ref.current?.applyChanges();
    });
  };

  const buildPayload = ({ userId }, { idForm, idRight }) => ({
    IdAgent,
    IdForm: Number(idForm),
    IdRight: Number(idRight),
    IdUser: Number(userId),
  });

  const buildPayloadList = ({ userId }, rows) =>
    rows.map(({ idForm, idRight }) => ({
      IdAgent,
      IdForm: Number(idForm),
      IdRight: Number(idRight),
      IdUser: Number(userId),
    }));

  return (
    <div className="flex flex-col gap-4 h-max">
      <div className="flex items-center justify-between">
        <h2>Agent Rights</h2>
        <div className="flex gap-2">
          <button
            type="button"
            onClick={handleSaveFromParent}
            className="btn btn-primary"
          >Save</button>


          <Changes
            classNameButton="w-fit"
            title="Agent Changes"
            params={{
              ChangeType: 6,
              IdSport: "",
              Param1: IdAgent,
              Param2: 0,
              Param3: 0,
            }}
          />
        </div>
      </div>
      <div className="grid grid-cols-2 gap-2">
        <SelectionRights
          ref={agentRightsRef}
          className="unlock-overflow"
          // GET
          getUrl={"/Agent/AgentRights_GetList"}
          getProcess={(data) =>
            data.filter(({ category }) => category === "AGENT")
          }
          // SELECTED
          getSelectedUrl={`/Agent/AgentRights_GetRights?idAgent=${IdAgent}`}
          getSelectedProcess={(data = []) =>
            data.map(({ idRight }) => idRight)
          }
          // INSERT
          insertUrl={"/Agent/AgentRights_AddRight"}
          insertParams={buildPayload}
          // INSERT ALL
          insertAllUrl={"/Agent/AgentRights_AddRights"}
          insertAllParams={buildPayloadList}
          // DELETE
          deleteUrl={"/Agent/AgentRights_RemoveRight"}
          deleteParams={buildPayload}
          // DELETE ALL
          deleteAllUrl={"/Agent/AgentRights_RemoveRights"}
          deleteAllParams={buildPayloadList}
        >
          <TableHeaderColumn
            visible="none"
            isKey={true}
            hidden
            dataField="idRight"
          >
            IdRight
          </TableHeaderColumn>
          <TableHeaderColumn dataField="description">Agent</TableHeaderColumn>
        </SelectionRights>
        <SelectionRights
          ref={agentReportRef}
          className="unlock-overflow"
          // GET
          getUrl={"/Agent/AgentRights_GetList"}
          getProcess={(data) =>
            data.filter(({ category }) => category === "AGENT REPORT")
          }
          // SELECTED
          getSelectedUrl={`/Agent/AgentRights_GetRights?idAgent=${IdAgent}`}
          getSelectedProcess={(data = []) => data.map(({ idRight }) => idRight)}
          // INSERT
          insertUrl={"/Agent/AgentRights_AddRight"}
          insertParams={({ userId }, { idForm, idRight }) => ({
            IdAgent,
            IdForm: Number(idForm),
            IdRight: Number(idRight),
            IdUser: Number(userId),
          })}
          // INSERT ALL
          insertAllUrl={"/Agent/AgentRights_AddRights"}
          insertAllParams={({ userId }, rows) =>
            rows.map(({ idForm, idRight }) => ({
              IdAgent,
              IdForm: Number(idForm),
              IdRight: Number(idRight),
              IdUser: Number(userId),
            }))
          }
          // DELETE
          deleteUrl={"/Agent/AgentRights_RemoveRight"}
          deleteParams={({ userId }, { idForm, idRight }) => ({
            IdAgent,
            IdForm: Number(idForm),
            IdRight: Number(idRight),
            IdUser: Number(userId),
          })}
          // DELETE ALL
          deleteAllUrl={"/Agent/AgentRights_RemoveRights"}
          deleteAllParams={({ userId }, rows) =>
            rows.map(({ idForm, idRight }) => ({
              IdAgent,
              IdForm: Number(idForm),
              IdRight: Number(idRight),
              IdUser: Number(userId),
            }))
          }
        >
          <TableHeaderColumn
            visible="none"
            isKey={true}
            hidden
            dataField="idRight"
          >
            IdRight
          </TableHeaderColumn>
          <TableHeaderColumn dataField="description">
            Agent Report
          </TableHeaderColumn>
        </SelectionRights>
      </div>
    </div>
  );
}

export default AgentRights;
